// @ts-strict-ignore
import { StringValueInLocalesVO } from '@project/components/article/model/vo/property.vo';
import { JsonObject, JsonProperty } from '../convert/convert-core';
import { ArticleVO } from '@article/model/vo/article.vo';

@JsonObject('RepresentationDataVO')
export class RepresentationDataVO {
  public static readonly CLASS_NAME: string = 'RepresentationDataVO';

  @JsonProperty('type', 'String')
  public type: string = undefined;

  public constructor() {
    this.type = RepresentationDataVO.CLASS_NAME;
  }
}

@JsonObject('RepresentationVO')
export class RepresentationVO {
  public static readonly TYPE_VIEW3D: string = 'VIEW3D';
  public static readonly TYPE_PREVIEW_VIEW3D: string = 'PREVIEW_VIEW3D';
//  public static readonly TYPE_PREVIEW_IMAGE: string = 'PREVIEW_IMAGE';
  public static readonly TYPE_IMAGE: string = 'IMAGE';
  public static readonly TYPE_PROJECT: string = 'PROJECT';
  public static readonly TYPE_ARTICLE: string = 'ARTICLE';

  @JsonProperty('type', 'String')
  public type: string = undefined;

  @JsonProperty('url', 'StringValueInLocalesVOConverter', true)
  public url: StringValueInLocalesVO = undefined;

  @JsonProperty('data', 'RepresentationDataVOConverter', true)
  public data: RepresentationDataVO = undefined;

  @JsonProperty('name', 'String')
  public name: string = undefined;

  @JsonProperty('repArticleId', 'Number')
  public repArticleId: number = undefined;

  @JsonProperty('repArticleVersion', 'Number')
  public repArticleVersion: number = undefined;

  @JsonProperty('sortOrder', 'Number')
  public sortOrder: number = undefined;

  @JsonProperty('projectId', 'Number')
  public projectId: number = undefined;

  @JsonProperty('projectVersion', 'Number')
  public projectVersion: number = undefined;
}

@JsonObject('OBJTextureDataVO')
export class OBJTextureDataVO {
  @JsonProperty('name', 'String')
  public name: string = undefined;

  @JsonProperty('content', '[Object]')
  public content: any[] = undefined;

  @JsonProperty('url', 'String')
  public url: string = undefined;

  @JsonProperty('articleParameters', 'String')
  public articleParameters: string = undefined;
}

@JsonObject('OBJRepresentationDataVO')
export class OBJRepresentationDataVO extends RepresentationDataVO {
  public static readonly CLASS_NAME: string = 'OBJRepresentationDataVO';

  @JsonProperty('modelData', '[Object]')
  public modelData: any[] = undefined;

  @JsonProperty('materialLibraryData', '[Object]')
  public materialLibraryData: any[] = undefined;

  @JsonProperty('modelDataString', 'String')
  public modelDataString: string = undefined;

  @JsonProperty('materialLibraryDataString', 'String')
  public materialLibraryDataString: string = undefined;

  @JsonProperty('textures', '[OBJTextureDataVO]')
  public textures: OBJTextureDataVO[] = undefined;

  @JsonProperty('compressed', 'Boolean')
  public compressed: boolean = undefined;

  @JsonProperty('encoded', 'Boolean')
  public encoded: boolean = undefined;

  constructor() {
    super();
    this.type = OBJRepresentationDataVO.CLASS_NAME;
  }
}

@JsonObject('RepresentationArticleVO')
export class RepresentationArticleVO {
  @JsonProperty('article', 'ArticleVO')
  public article: ArticleVO = undefined;

  @JsonProperty('markingSystemTypeId', 'Number')
  public markingSystemTypeId: number = undefined;

  @JsonProperty('isRecommended', 'Boolean')
  public isRecommended: boolean = undefined;

  @JsonProperty('separationRequired', 'Boolean')
  public separationRequired: boolean = undefined;
}
